import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// IM-API
enum API {
  // iM接口签名
  ImUserSig = '/hk-web/im/userSig',
  // 查询用户封禁
  ImQueryUserForbidStatus = '/hk-web/im/queryUserForbidStatus',
  // 删除聊天消息
  ImDeleteMsg = '/hk-web/im/delete/msg',
  // 查询用户角色
  ImUserRole = '/hk-web/im/user/role',
}

export type TGetImUserSigParams = {
  lang?: number // 语言:1中文,2非中文
  status?: number // 直播状态，:1待开播2直播中3直播结束4下架直播
  current?: number // 当前页数
  size?: number // 每页数据量
}
export type TGetImUserSigResponse = TResponse<{
  userId?: string // 用户UID
  userSig?: string // userSig
}>
export const getImUserSig = (params?: TGetImUserSigParams) => {
  return hcAxios.get<TGetImUserSigResponse>(API.ImUserSig, { params })
}

export type TGetImQueryUserForbidStatusParams = {
  roomId?: any // 直播间id
  userId?: any // 用户id
}
export type TGetImQueryUserForbidStatusResponse = TResponse<{
  banStatus?: boolean // 0-未封禁,1-封禁
  forbidStatus?: boolean // 0-未禁言,1-禁言
}>
export const getImQueryUserForbidStatus = (params?: TGetImQueryUserForbidStatusParams) => {
  return hcAxios.get<TGetImQueryUserForbidStatusResponse>(API.ImQueryUserForbidStatus, { params })
}

export type TPostImDeleteMsgParams = {
  groupId?: string // 直播间ID
  msgSeq?: number // 消息ID
  userId?: number // 用户UID
}
export type TPostImDeleteMsgResponse = TResponse<any>
export const postImDeleteMsg = (params?: TPostImDeleteMsgParams) => {
  return hcAxios.post<TPostImDeleteMsgResponse>(API.ImDeleteMsg, params)
}

export type TGetImUserRoleParams = any
export type TGetImUserRoleResponse = TResponse<{
  role?: string // 用户角色： Owner/Admin : /Member/NotMember
}>
export const getImUserRole = (params?: TGetImUserRoleParams) => {
  return hcAxios.get<TGetImUserRoleResponse>(API.ImUserRole, { params })
}
